/*
<summary>
   This file is all about defining the dropdown option lists used across the Tool
   Management module. UsageStatus/InspectionStatus/InspectionFormat/CalibrationStatus/
   LoanRecord/InspectionCycle are driven by the fixed enums in constants/enums (the
   tool_master columns for these fields are integers).
   Developer: Aashish Singh, Created Date: 20-Aug-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns module exports</returns>
*/

import { IOption } from '../../models/ICommon';
import CalibrationStatusEnum from '../../constants/enums/calibration-status-enum';
import InspectionCycleEnum from '../../constants/enums/inspection-cycle-enum';
import InspectionFormatEnum from '../../constants/enums/inspection-format-enum';
import InspectionStatusEnum from '../../constants/enums/inspection-status-enum';
import LoanRecordEnum from '../../constants/enums/loan-record-enum';
import MountingStatusEnum from '../../constants/enums/mounting-status-enum';
import UsageStatusEnum from '../../constants/enums/usage-status-enum';

// Usage Status options
export const ToolUsageStatusOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: UsageStatusEnum.InUse, value: 'usage_status_in_use', disabled: false },
  { id: UsageStatusEnum.OnLoan, value: 'usage_status_on_loan', disabled: false },
  { id: UsageStatusEnum.Unused, value: 'usage_status_unused', disabled: false },
  { id: UsageStatusEnum.Unavailable, value: 'usage_status_unavailable', disabled: false },
  { id: UsageStatusEnum.Unusable, value: 'usage_status_unusable', disabled: false },
];
// This separate options is used for add & edit tool form
export const ToolUsageStatusAddEditOptions: IOption[] = ToolUsageStatusOptions.map((option) => ({
  ...option,
  disabled:
    option.id !== -1 &&
    option.id !== UsageStatusEnum.Unusable &&
    option.id !== UsageStatusEnum.Unused &&
    option.id !== UsageStatusEnum.Unavailable,
}));

// Inspection Status options
export const ToolInspectionStatusOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: InspectionStatusEnum.Inspected, value: 'inspection_status_inspected', disabled: false },
  { id: InspectionStatusEnum.NotInspected, value: 'inspection_status_not_inspected', disabled: false },
];

// Calibration Status options
export const ToolCalibrationStatusOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: CalibrationStatusEnum.Valid, value: 'calibration_status_valid', disabled: false },
  { id: CalibrationStatusEnum.Warning, value: 'calibration_status_warning', disabled: false },
  { id: CalibrationStatusEnum.Expired, value: 'calibration_status_expired', disabled: false },
];

// Loan Record options
export const ToolLoanRecordOptions: IOption[] = [
  { id: LoanRecordEnum.No, value: 'loan_record_no', disabled: false },
  { id: LoanRecordEnum.Yes, value: 'loan_record_yes', disabled: false },
];

// Inspection Cycle options — rendered as radio buttons; selecting "Periodic" reveals the
// InspectionInterval number-of-days input.
export const ToolInspectionCycleOptions: IOption[] = [
  { id: InspectionCycleEnum.PreWork, value: 'inspection_cycle_pre_work', disabled: false },
  { id: InspectionCycleEnum.OnApplicatorSwap, value: 'inspection_cycle_on_applicator_swap', disabled: false },
  { id: InspectionCycleEnum.Periodic, value: 'inspection_cycle_periodic', disabled: false },
  { id: InspectionCycleEnum.None, value: 'inspection_cycle_none', disabled: false },
];

// Inspection Format options
export const ToolInspectionFormatOptions: IOption[] = [
  { id: -1, value: 'please_select', disabled: false },
  { id: InspectionFormatEnum.CrimpingToolInspection, value: 'inspection_format_crimping_tool', disabled: false },
  { id: InspectionFormatEnum.UserCreated, value: 'inspection_format_user_created', disabled: false },
];

// Mounting Status options — Main Unit/Applicator tool rows only.
export const ToolMountingStatusOptions: IOption[] = [
  { id: MountingStatusEnum.Mounted, value: 'mounting_status_mounted', disabled: false },
  { id: MountingStatusEnum.NotMounted, value: 'mounting_status_not_mounted', disabled: false },
];
